module.exports = __webpack_public_path__ + "static/img/gaozhongyuwen.2f038cad.jpg";